import DOCUMENT_CONFIGS from './documentsVerificationConstants';

export default [
    {
        events: [
            DOCUMENT_CONFIGS.FUTURE_LOSS_OF_MEC,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID,
            DOCUMENT_CONFIGS.LOSS_OF_MEC,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID_FUTURE,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EXISTING_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.DENIAL_LETTER_FROM_YOUR_STATE,
                    DOCUMENT_CONFIGS.HEALTH_CARE_PROGRAM_DOCUMENT,
                    DOCUMENT_CONFIGS.LETTER_ABOUT_COBRA_COVERAGE,
                    DOCUMENT_CONFIGS.LETTER_FOR_LOSS_OF_STUDENT_COVERAGE,
                    DOCUMENT_CONFIGS.LETTER_FROM_A_GOVERNMENT_ORGANIZATION,
                    DOCUMENT_CONFIGS.LETTER_FROM_AN_EMPLOYER,
                    DOCUMENT_CONFIGS.LETTER_OF_EXPLANATION,
                    DOCUMENT_CONFIGS.LETTER_STATING_LOST_COVERAGE,
                    DOCUMENT_CONFIGS.MARKETPLACE_LETTER,
                    DOCUMENT_CONFIGS.SCREENSHOT_OF_RESULTS,
                    DOCUMENT_CONFIGS.DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DEATH,
                    DOCUMENT_CONFIGS.DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DIVORCE_SEPARATION,
                    DOCUMENT_CONFIGS.OTHER,
                    DOCUMENT_CONFIGS.PAY_STUBS,
                ],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.ICHRA_SEP,
            DOCUMENT_CONFIGS.ICHRA_SEP_FUTURE,
            DOCUMENT_CONFIGS.QSEHRA_SEP,
            DOCUMENT_CONFIGS.QSEHRA_SEP_FUTURE,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_HRA_OFFER,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.HRA_OFFER_DOCUMENT],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.UNSUPPORTED_EVENT],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_PROVING_EVENT,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.DOC_SUPPORTING_EVENT],
            },
        ],
    },
];
